import type { TFunction } from 'i18next';
import * as yup from 'yup';

import { ProcessUpdateDtoAssessmentType } from '@/api/generated';
import { PROCESS_SETTINGS_STEP_KEYS } from '@/root/linker';

export const getProcessSettingsBasicInfoValidation = (t: TFunction) =>
  yup.object().shape({
    [PROCESS_SETTINGS_STEP_KEYS.BASIC_INFO]: yup.object().shape({
      assessmentType: yup
        .string()
        .oneOf(Object.values(ProcessUpdateDtoAssessmentType))
        .required(
          t('validation:mandatory', {
            field: t('settings:processSettings.form.basicInfo.assessmentType')
          })
        ),
      description: yup.string().optional()
    })
  });
